import PropTypes from 'prop-types';

export default {
  id: PropTypes.number,
  question: PropTypes.string,
  answer: PropTypes.string,
};